// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2CJ3q","inner":"Form_inner__1i3JI","range":"Form_range__6Rp-3","name":"Form_name__jrGXx","actions":"Form_actions__3ukzw"};